class Playtopia {
    constructor(config) {
        Errors.attachGlobalErrorHandler();
        this.config = config;
        this.timeOffset = ((new Date()).getTime()) - config.serverTime;
        this.connectionManager = null;
        if (config.user !== undefined) {
            let xmppResource = new XMPPResource(config, this.whereIsUser());
            let authProvider = new AuthTokenProvider(config);
            this.connectionManager = new ConnectionManager(xmppResource, authProvider, config);
            this.tournaments = new Tournaments(this.connectionManager, config);
            this.chatWrapper = new ChatWrapper(this.connectionManager, config);
            this.wallet = new Wallet(this.connectionManager);
            this.notifications = new Notifications(this.connectionManager);
            this.shop = new Shop(this.connectionManager);
        }
        this.prize = new Prize(this.connectionManager, config);
        this.ajax = new Ajax();
        this.events = new Events();
        this.navigation = new Navigation();
        this.storage = new AppStorage(this.timeOffset);
        this.util = new Utilities();
        this.alert = new Alert();
        this.animations = new Animations();
        this.auth = new Auth();
        this.confirm = new Confirm();
        this.dropzone = new AppDropzone();
        this.imageUpload = new ImageUpload();
        this.form = new Form();
        this.modal = new Modal();
        this.launcher = new Launcher();
        this.validation = new Validation();
        this.challenges = new Challenges();
        this.highscores = new Highscores();
        this.gameRating = new GameRating();
        this.gameReview = new GameReview();
        this.gameStatistics = new GameStatistics();
        this.guestbook = new Guestbook();
        this.userProfile = new UserProfile();
        this.reportContent = new ReportContent();
        this.blockedUsers = new BlockedUsers();
        this.messages = new Messages();
        this.friends = new Friends();
        this.uploader = new Uploader();
        this.gifts = new Gifts();
        this.favourites = new Favourites();
        this.search = new Search();
        this.sharedPrizes = new SharedPrizes(this);
        this.profileSubMenu = new ProfileSubMenu();
        this.accordion = new Accordion();
        this.sounds = new Sounds();
        this.analytics = new Analytics();
    }

    whereIsUser() {
        const splittedUri = window.location.href.split("/");
        let whereIsUser = "website";
        for (let i in splittedUri) {
            if (splittedUri[i] === "play") {
                whereIsUser = splittedUri[i - 1];
            }
        }
        return whereIsUser;
    }

    init() {
        if (this.config.user !== undefined) {
            this.notifications.init();
            this.search.init();
            window.live_counter_bar = new LiveCounter(null, true);
        }
        this.analytics.init(this.config);
        this.navigation.init();
        window.addEventListener("blur", () => {
            this.config.isFocused = false;
        });
        window.addEventListener("focus", () => {
            this.config.isFocused = true;
        });
    }
}
